import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { invoiceAPI } from "../services/api";

const PublicInvoiceViewer: React.FC = () => {
    const { generationId } = useParams<{ generationId: string }>();

    useEffect(() => {
        if (generationId) {
          const pdfUrl = invoiceAPI.previewPDF(generationId);
          window.location.replace(pdfUrl);
        }
    }, [generationId]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
                <Loader2 className="w-8 h-8 text-blue-600 animate-spin mx-auto mb-4" />
                <p className="text-gray-600">Loading invoice...</p>
            </div>
        </div>
    );
};

export default PublicInvoiceViewer;
